module.exports = require("@visx/xychart");